import Keycloak from 'keycloak-js';

/**
 * The login id stamped onto a batch — as `user_name` on upload and as `imported_by`
 * on import. Both must resolve identically or the same person appears under two names
 * on the same batch, which is why this lives here rather than being re-derived per caller.
 *
 * preferred_username is the login id: stable, unique, and unaffected by display-name
 * edits. Falls back to 'unknown' rather than inventing a name — a wrong attribution is
 * worse than an absent one, and authGuard means an unauthenticated user can't reach
 * these screens anyway.
 */
export function resolveUserName(keycloak: Keycloak): string {
  const claims = keycloak.tokenParsed as
    | { preferred_username?: string; name?: string; email?: string }
    | undefined;
  return claims?.preferred_username?.trim()
    || claims?.name?.trim()
    || claims?.email?.trim()
    || 'unknown';
}
